import React from "react";

export default function LandingSoldOutMessageCampaigns() {

	return (
		<>
			<div className={"content-sold-out-campaign"} >

				<h1 style={{marginTop:40,marginBottom:40}}>Thank you - our Snip'n'chip campaign for your region is now fully booked!</h1>

				<h2>We’d like to say a huge thank you for all your awesome work in helping us to spread the word!</h2>
				<p>
					We're sorry to disappoint anyone who missed out on making an appointment.<br />
					We have compiled some other options that may help you with desexing your animal:
				</p>
				<p>
					<strong>Compare vet clinic prices:</strong>
					The cost can vary between vet clinics and we recommend calling around to compare prices. There are some vet clinics across the country that provide low cost desexing, as well as payment plans. Each vet clinic will be able to discuss their individual processes and requirements, and answer any questions you may have. Generally kittens will need to be at least 1kg (approximately 10-12 weeks old) before they can be desexed.
				</p>
				<p>
					<strong>Look into other services</strong>: Other organisations or social services in your area may be able to offer desexing services or provide financial assistance. Most of these can be found online through Google.
				</p>
				<p>
					<strong>Check in regularly at 'Help someone desex their pet':</strong> <a href={"https://www.facebook.com/Helpsomeonefixtheirpet/"} target={"_blank"}>Help Someone desex their pet</a> is a great resource page on Facebook that lists desexing options around the country and is updated regularly.
				</p>

				<p>Alternatively, you can contact your local SPCA Centre to discuss desexing options in the area.</p>
				<p>Together, we can make a difference in the lives of the thousands of unwanted cats born each year across the country. Thank you to our generous supporters and participating vet clinics for making this Snip ‘n’ Chip campaign possible.				</p>
			</div>
		</>
	)

}
